import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, withCredentials: true });

// Auth
export const login = (username, password) => http.post("/auth/login", { username, password }).then(r => r.data);
export const fetchMe = () => http.get("/auth/me").then(r => r.data);
export const logoutApi = () => http.post("/auth/logout").then(r => r.data);

// Users (super_admin)
export const listUsers = () => http.get("/users").then(r => r.data);
export const createUser = (data) => http.post("/users", data).then(r => r.data);
export const updateUser = (id, data) => http.put(`/users/${id}`, data).then(r => r.data);
export const deleteUser = (id) => http.delete(`/users/${id}`).then(r => r.data);
export const getPermissionsCatalog = () => http.get("/permissions/catalog").then(r => r.data);

// Meta
export const fetchMeta = () => http.get("/meta").then(r => r.data);

// New Students
export const listNewStudents = (params = {}) => http.get("/new-students", { params }).then(r => r.data);
export const createNewStudent = (data) => http.post("/new-students", data).then(r => r.data);
export const updateNewStudent = (id, data) => http.put(`/new-students/${id}`, data).then(r => r.data);
export const deleteNewStudent = (id) => http.delete(`/new-students/${id}`).then(r => r.data);

// Withdrawn Students
export const listWithdrawnStudents = (params = {}) => http.get("/withdrawn-students", { params }).then(r => r.data);
export const createWithdrawnStudent = (data) => http.post("/withdrawn-students", data).then(r => r.data);
export const updateWithdrawnStudent = (id, data) => http.put(`/withdrawn-students/${id}`, data).then(r => r.data);
export const deleteWithdrawnStudent = (id) => http.delete(`/withdrawn-students/${id}`).then(r => r.data);

// Stats
export const getStats = (params = {}) => http.get("/stats", { params }).then(r => r.data);

// Excel Import
export const importStudents = (file, target, academic_year = "") => {
  const fd = new FormData();
  fd.append("file", file);
  return http.post(`/import/students?target=${target}&academic_year=${encodeURIComponent(academic_year)}`, fd, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(r => r.data);
};

// Promotion (admin)
export const promotePreview = (target_year = null) => http.post("/promote/preview", { target_year }).then(r => r.data);
export const promoteExecute = (target_year = null) => http.post("/promote/execute", { confirm: true, target_year }).then(r => r.data);
export const listGraduated = () => http.get("/graduated-students").then(r => r.data);

// Attendance
export const attendanceStudents = (stage, grade, section) =>
  http.get("/attendance/students", { params: { stage, grade, section } }).then(r => r.data);
export const getAttendance = (date, stage, grade, section) =>
  http.get("/attendance", { params: { date, stage, grade, section } }).then(r => r.data);
export const saveAttendance = (data) => http.post("/attendance", data).then(r => r.data);
export const attendanceReports = (params) => http.get("/attendance/reports", { params }).then(r => r.data);

// Lesson Plans (Phase 3)
export const saveLessonPlan = (data) => http.post("/lesson-plans", data).then(r => r.data);
export const listLessonPlans = (params = {}) => http.get("/lesson-plans", { params }).then(r => r.data);
export const getLessonPlan = (id) => http.get(`/lesson-plans/${id}`).then(r => r.data);
export const deleteLessonPlan = (id) => http.delete(`/lesson-plans/${id}`).then(r => r.data);
export const deleteLessonPlanCell = (planId, cellKey) => http.delete(`/lesson-plans/${planId}/cells/${cellKey}`).then(r => r.data);

// WhatsApp (Phase 4)
export const getWaTemplate = () => http.get("/whatsapp/template").then(r => r.data);
export const createWaMessage = (data) => http.post("/whatsapp/messages", data).then(r => r.data);
export const updateWaStatus = (id, status) => http.patch(`/whatsapp/messages/${id}?status=${status}`).then(r => r.data);
export const listWaMessages = (params = {}) => http.get("/whatsapp/messages", { params }).then(r => r.data);
export const deleteWaMessage = (id) => http.delete(`/whatsapp/messages/${id}`).then(r => r.data);
export const waStats = () => http.get("/whatsapp/stats").then(r => r.data);

// Pickup (نظام استدعاء الطالب) — واجهة المعلم/الإدارة (تستخدم نفس نظام الكوكيز)
export const pickupTeacherStudents = (params) => http.get("/pickup/teacher/students", { params }).then(r => r.data);
export const pickupConfirmExit = (rid) => http.post(`/pickup/requests/${rid}/exit`).then(r => r.data);
export const pickupSchoolBoard = (params = {}) => http.get("/pickup/school/requests", { params }).then(r => r.data);
export const pickupConfirmDelivery = (rid) => http.post(`/pickup/requests/${rid}/deliver`).then(r => r.data);
export const pickupGetAllStageSettings = () => http.get("/pickup/stage-settings").then(r => r.data);
export const pickupUpdateStageSettings = (stage, data) => http.put(`/pickup/stage-settings/${stage}`, data).then(r => r.data);
export const pickupListGuardians = (params = {}) => http.get("/pickup/admin/guardians", { params }).then(r => r.data);
export const pickupGuardiansStats = (params = {}) => http.get("/pickup/admin/guardians/stats", { params }).then(r => r.data);
export const pickupResetGuardianPassword = (gid, new_password) => http.put(`/pickup/admin/guardians/${gid}/password`, { new_password }).then(r => r.data);
export const pickupDutySearchStudents = (params) => http.get("/pickup/duty/students", { params }).then(r => r.data);
export const pickupDutyCall = (student_id) => http.post("/pickup/duty/call", { student_id }).then(r => r.data);
export const pickupDeleteGuardian = (gid) => http.delete(`/pickup/admin/guardians/${gid}`).then(r => r.data);
export const pickupUnlinkStudent = (linkId) => http.delete(`/pickup/admin/links/${linkId}`).then(r => r.data);
export const pickupAdminLink = (data) => http.post("/pickup/admin/link", data).then(r => r.data);

export default http;

// ============ التعاميم الداخلية ============
export const circularsListEmployees = () => http.get("/circulars/employees").then(r => r.data);
export const circularsCreate = (data) => http.post("/circulars", data).then(r => r.data);
export const circularsIssue = (cid) => http.post(`/circulars/${cid}/issue`).then(r => r.data);
export const circularsPreview = (cid) => http.get(`/circulars/${cid}/preview`, { responseType: "text" }).then(r => r.data);
export const circularsOutgoing = (q) => http.get("/circulars/outgoing", { params: { q } }).then(r => r.data);
export const circularsIncoming = () => http.get("/circulars/incoming").then(r => r.data);
export const circularsGet = (cid) => http.get(`/circulars/${cid}`).then(r => r.data);
export const circularsSign = (cid, signature_data_url) => http.post(`/circulars/${cid}/sign`, { signature_data_url }).then(r => r.data);
export const circularsTracking = (cid, unsigned_only) => http.get(`/circulars/${cid}/tracking`, { params: { unsigned_only } }).then(r => r.data);
export const circularsRemind = (cid) => http.post(`/circulars/${cid}/remind`).then(r => r.data);
export const circularsArchive = (params) => http.get("/circulars", { params }).then(r => r.data);
export const circularsPdfUrl = (cid) => `${API}/circulars/${cid}/pdf`;

// إشعارات عامة
export const notificationsList = () => http.get("/circulars/notifications/list").then(r => r.data);
export const notificationsUnreadCount = () => http.get("/circulars/notifications/unread-count").then(r => r.data);
export const notificationsMarkRead = (nid) => http.post(`/circulars/notifications/${nid}/read`).then(r => r.data);
export const circularsDelete = (cid) => http.delete(`/circulars/${cid}`).then(r => r.data);
